import React, { useContext } from 'react';
import { Layout, Menu, Typography, Avatar, Dropdown, Space, Button, Popconfirm } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserOutlined, DownOutlined, HomeOutlined, BookOutlined, EditOutlined, UserAddOutlined } from '@ant-design/icons';
import { AuthContext } from '../../contexts/AuthContext';
import './Header.css';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  // 根据用户身份决定是否显示写文章选项
  const showWriteOption = user && user.name === 'qmau';

  // 构建菜单项
  const menuItems = [
    {
      key: '/',
      label: <Link to="/">首页</Link>,
      icon: <HomeOutlined />,
    },
    {
      key: '/about',
      label: <Link to="/about">关于</Link>, 
      icon: <UserAddOutlined />,
    },
    {
      key: '/archive',
      label: <Link to="/archive">文章归档</Link>,
      icon: <BookOutlined />,
    },
  ];

  // 如果是qmau用户，则添加写文章选项
  if (showWriteOption) {
    menuItems.push({
      key: '/write',
      label: <Link to="/write">写文章</Link>,
      icon: <EditOutlined />,
    });
  }

  // 定义用户菜单项
  const userMenuItems = [
    {
      key: 'profile',
      label: <Link to="/profile">个人中心</Link>,
    },
    {
      key: 'switchAccount',
      label: <Link to="/auth">切换账号</Link>,
    },
    {
      key: 'logout',
      label: (
        <Popconfirm
          title="确认退出登录?"
          onConfirm={handleLogout}
          okText="是"
          cancelText="否"
        >
          <span style={{ color: 'red' }}>退出登录</span>
        </Popconfirm>
      ),
    }
  ];

  const onClickMenuItem = (e) => {
    if (e.key === 'logout') {
      handleLogout();
    } else if (e.key === 'switchAccount') {
      navigate('/auth');
    }
  };

  return (
    <AntHeader className="blog-header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <Text strong style={{ fontSize: '24px', color: '#1890ff' }}>Qmau的博客</Text>
          </Link>
        </div>
        <Menu 
          theme="light" 
          mode="horizontal" 
          selectedKeys={[location.pathname]}
          items={menuItems}
          style={{ flex: 1, minWidth: 0 }}
        />
        <div className="user-section">
          {user ? (
            <Dropdown
              menu={{ items: userMenuItems, onClick: onClickMenuItem }}
              trigger={['click']}
              placement="bottomRight"
            >
              <Space style={{ cursor: 'pointer' }}>
                <Avatar src={user.avatar || <UserOutlined />} size={40} />
                <span>{user.name}</span>
                <DownOutlined />
              </Space>
            </Dropdown>
          ) : (
            <>
              <Button type="default" onClick={() => navigate('/auth')} style={{ marginRight: 8 }}>
                登录
              </Button>
              <Button type="primary" onClick={() => navigate('/auth')}>
                注册
              </Button>
            </>
          )}
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;